
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

export interface ISignInCredentials {
  email: string;
  password: string;
}

export interface ICreateCredentials {
  email: string;
  password: string;
  displayName: string;
}

export interface IPasswordReset {
  code: string;
  newPassword: string;
}

const baseUrl = environment.api_url;

@Injectable({ providedIn: 'root' })
export class AuthService {
  protected API_ENDPOINT = 'client/profile';
  public loginRoute = 'user/login';

  constructor(private http: HttpClient, private router: Router) {}
  
  // Login
  login(user: ISignInCredentials): Observable<any> {
    return this.http.post<any>(`${baseUrl}${this.loginRoute}`, user);
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/authentication/login']);
  }

}